// // import environment from "@/configs/environment.js";
export default {
    name: "ValuationMixin",
    methods: {        
        _saveChangesValuation: function(modalAddorEdit,InfoJSONData,modelName) {
            let self=this;
           
                if (modalAddorEdit == "add") {
                  // Add Popup                  
                  console.log(JSON.stringify(InfoJSONData));            
                  let addFormValues = InfoJSONData;                   
                  let createItem = { list:modelName, payload:addFormValues };
                  //let loader = this.$loading.show();
                  self._APICrudPopup("APICrudpopup");
                  this.CreateItems(createItem).then((res) => {
                      self.$emit("SaveComplete");
                      self._AlertPopup("Data Saved Successfully!","success");
                      self.resetFields();
                  }).catch(error=>{
                    self._AlertPopup("Some Error Occurred!","info");
                  }).finally(()=>{
                    //loader.hide();
                  })
                  
                } else {
                  // Edit Popup             
                  console.log(JSON.stringify(InfoJSONData));
                  let editFormValues = InfoJSONData;                  
                  let updateItem = { list:modelName, payload:editFormValues };
                  //let loader = this.$loading.show();
                  self._APICrudPopup("APICrudpopup");
                  this.UpdateItems(updateItem).then((res) => {
                      //loader.hide();
                      self.$emit("SaveComplete");
                      self._AlertPopup("Data Saved Successfully!","success");
                      self.resetFields();
                  }).catch(error=>{
                    self._AlertPopup("Some Error Occurred!","info");
                  }).finally(()=>{
                    //loader.hide();
                  })
                  
                }
                  $("#BaseModal").modal("toggle");
          },
          _resetFieldsValuation: function() {
            // let self=this;
            //  this.$refs.refProgramForm.$refs.ProgramForm.reset();
            this.displayErrors = false;
            this.errors.clear();
            this.customerrors=[];
          },
          getaddeditems:function(objdata){
            let filteredData= objdata.filter(function(e) {
				return (
                e["Id"] == 0 || e["Id"] == null || e["Id"] == undefined
               )
			});
			return filteredData;			
         },   

    }
}